import { Nullable } from 'modules/types/common';

export type DateString = string;
export type NumericString = string;

export interface EducationItem {
  accessCode: string;
  adapterSource: string;
  completedCount: string;
  created: DateString;
  firstCompleted: DateString;
  firstStarted: DateString;
  issueDate: DateString;
  lastChange: DateString;
  lastSection: NumericString;
  maxSection: NumericString;
  postSurgery: NumericString;
  programName: string;
  questions: NumericString;
  startedCount: NumericString;
  status: string;
  totalSections: NumericString;
  url: string;
  viewBy: DateString;
  viewerCode: NumericString;
  viewerCodeDesc: string;
  customerNotes: string;
}

export interface EducationCounts {
  totalCount: number;
  completeCount: number;
  incompleteCount: number;
}

export interface PatientEducationListState {
  isFetching: boolean;
  error: Nullable<Error>;
  data: Nullable<EducationItem[]>;
  requestState: string;
  lastUpdated: string;
}

export enum EducationType {
  action = 'ACTION',
  historical = 'HISTORICAL'
}
